module.exports = __webpack_public_path__ + "img/child-torso.d1aaba61.png";